import { set, toggle } from '../../utils'

export const mutations = {
  setDarkMode: set('darkMode'),
  toggleDarkMode: toggle('darkMode'),
  setNavigationDrawer: set('navigationDrawer'),
  toggleNavigationDrawer: toggle('navigationDrawer')
}

export default mutations
